import { Component, Element, h, Host, Prop } from '@stencil/core'
import { GridClass, GridSizesType } from './constants'
import { govHost } from '../../helpers/Dom/template'
import { GovHost } from '../../helpers/Dom/template.types'

@Component({
	tag: 'gov-grid',
})
export class GovGrid {
	private h: GovHost

	constructor() {
		this.h = govHost(this.host)
	}

	@Element() host: HTMLGovGridElement

	/**
	 * Horizontal align of cells
	 */
	@Prop({ attribute: 'align-items', reflect: true }) alignItems?: 'start' | 'center' | 'end' | 'stretch';

	/**
	 * Vertical align of cells
	 */
	@Prop({ attribute: 'justify-items', reflect: true }) justifyItems?: 'start' | 'center' | 'end' | 'stretch';

	/**
	 * The gap property creates consistent spacing between flex items in the container.
	 */
	@Prop({ attribute: 'gap', reflect: true }) gap?: GridSizesType;

	render() {
		return (
			<Host class={this.h.classes(GridClass.root)} role="list">
				<slot></slot>
			</Host>
		)
	}
}
